import { render } from "./AreaOfStudyOptionButtons.vue?vue&type=template&id=10b9d8ab&scoped=true"
import script from "./AreaOfStudyOptionButtons.vue?vue&type=script&lang=js"
export * from "./AreaOfStudyOptionButtons.vue?vue&type=script&lang=js"

import "./AreaOfStudyOptionButtons.vue?vue&type=style&index=0&id=10b9d8ab&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-10b9d8ab"

export default script